<div class="table-header-container" *ngIf="isDesktop">
  <app-table-header
    [hidden]="!customersMetrics || !customersMetrics.length"
    [dataColumns]="[
      {
        size: '2',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' + HeaderFields.customer
          | translate,
        sortField: HeaderFields.customer,
        sortDirectionByDefault: SortDirection.ASC,
        dataCyName: 'ar-aging-customer-information',
      },
      {
        size: '1.6',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.percentageCurrent | translate,
        sortField: HeaderFields.percentageCurrent,
        dataCyName: 'ar-aging-percent-current',
      },
      {
        size: isShrink ? '1.6' : '2.4',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' + HeaderFields.term
          | translate,
        sortField: HeaderFields.term,
        sortDirectionByDefault: SortDirection.ASC,
        dataCyName: 'ar-aging-term',
      },
      {
        size: isShrink ? '1.6' : '1.4',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.oneSevenDays | translate,
        sortField: HeaderFields.oneSevenDays,
        dataCyName: 'ar-aging-one-seven-days',
      },
      {
        size: isShrink ? '1.6' : '1.4',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.eightFifteenDays | translate,
        sortField: HeaderFields.eightFifteenDays,
        dataCyName: 'ar-aging-eight-fifteen-days',
      },
      {
        size: isShrink ? '1.6' : '1.4',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.sixteenThirtyDays | translate,
        sortField: HeaderFields.sixteenThirtyDays,
        dataCyName: 'ar-aging-sixteen-thirty-days',
      },

      {
        size: isShrink ? '1.6' : '1.4',
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.thirtyPlus +
            'DPT' | translate,
        sortField: HeaderFields.thirtyPlus,
        dataCyName: 'ar-aging-thirty-plus',
      },
    ]"
    [sortField]="sortedField"
    [sortDirection]="sortedDirection"
    (clickEmit)="handleSort($event)"
  ></app-table-header>
</div>

<div class="ar-aging-rows">
  <ng-container *ngIf="isDesktop; else isTouch">
    <app-ar-aging-row-desktop
      *cdkVirtualFor="let customerMetrics of customersMetrics"
      [customerMetrics]="customerMetrics"
      [isShrink]="isShrink"
      (emitClickTerm)="changeTableSizes($event)"
    ></app-ar-aging-row-desktop>
  </ng-container>

  <ng-template #isTouch>
    <app-ar-aging-row-touch
      *cdkVirtualFor="let customerMetrics of customersMetrics"
      [customerMetrics]="customerMetrics"
    ></app-ar-aging-row-touch>
  </ng-template>
</div>
